import React from 'react';
import { Button, Card } from 'react-bootstrap';
import { PageHeader, Inquiries, GradientFallback } from '../Globals';

function EventSorting(props) {
  const today = new Date().toISOString().substring(0, 10);

  // Separate events into two arrays
  let upcomingEvents = props.events.filter(event => event.date > today);
  upcomingEvents = upcomingEvents.sort((a, b) => new Date(a.date) -  new Date(b.date));
  let pastEvents = props.events.filter(event => event.date <= today);
  pastEvents = pastEvents.filter(event => event.postLink !== "");
  pastEvents = pastEvents.sort((a, b) => new Date(b.date) - new Date(a.date));

  const upcomingCards = upcomingEvents.map((event, i) => <EventCard name={event.name} date={event.date} location={event.location} image={event.image} description={event.description} link={event.preLink} isPre="true" key={"up"+i} />);
  const pastCards = pastEvents.map((event, i) => <EventCard name={event.name} date={event.date} location={event.location} image={event.image} description={event.description} link={event.postLink} isPre="" key={"past"+i} />);

  return(
    <>
      <div className="px-md-5">
        <h2 className="text-center text-md-start">Upcoming Events</h2>
        <div className="col-12 my-auto">
          <div className="row d-flex justify-content-center mx-1">
            {upcomingCards}
          </div>
        </div>
        <Inquiries hide="" />
        <div id="recordings" className='pt-5'>
        <h2 id="recordings2" className="text-center text-md-start pt-5">Past Events</h2>
        <div className="col-12 my-auto">
          <div className="row d-flex justify-content-center mx-1">
            {pastCards}
          </div>
        </div>
        </div>
      </div>
    </>
  );
}

export function EventCard(props) {
  return (
    <Card className="col-12 col-md-5 m-1 m-md-3">
      <Card.Body
          as={props.link ? "a" : "div"}
          href={props.link || undefined} target={props.link ? "_blank" : undefined}
          rel={props.link ? "noopener noreferrer" : undefined}
          className="px-3 py-3 d-flex flex-column justify-content-center"
        >
          {props.image ? <Card.Img variant="middle" src={props.image}
            className="bg-light" style={{ maxWidth: "100%", maxHeight: "270px", objectFit: "contain" }}
          />
          : <GradientFallback type={!props.isPre ? "Video" : ""} />}
          <Card.Title as="h5" className="my-2">
            {props.name}
          </Card.Title>
          <Card.Subtitle as="p" className="text-muted small mb-2">
            <em>{props.date} &ensp;·&ensp; {props.location}</em>
          </Card.Subtitle>
          <Card.Text className="text-muted small flex-grow-1 desc-trunc">
            {props.description}
          </Card.Text>
            {props.link && <Button as="a" href={props.link} target="_blank" rel="noopener noreferrer" variant="secondary" className="bg-blue">{props.isPre ? "Go to Event" : "Watch Recording"}</Button>}
        </Card.Body>
    </Card>
  );
}

export default function Events(props) {
  const pageTitle = "Events";
  const pageDescription = "See details for upcoming events, and watch the recordings of past events";
  // const pageDescription = "See details for Alvin's upcoming events, and watch the recordings of past events";
  
  return (
    <main>
      <div className="container pt-4">
        <div className="row d-flex justify-content-center">
          <PageHeader title={pageTitle} description={pageDescription}/>
          {props.isFetching ? '' : <EventSorting events={props.events} />}
        </div>
      </div>
    </main>
  );
}
